export const DISPLAY_UNIT_ENUM = {
  HOURS: 'hours',
  PERCENTAGE: 'percentage'
};
export const DEFAULT_DISPLAY_UNIT = DISPLAY_UNIT_ENUM.HOURS;
